module.exports = __webpack_public_path__ + "img/logistic-system.cc8d7bda.png";